// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__2c4Re","selected":"Chip_selected__1J_dA"};